export const Homeslides = [
  {
    title: "Executive & Leadership Collections",
    subtitle:
      "Premium Director and Executive series for sophisticated corporate environments",
    background:
      "https://images.unsplash.com/photo-1497366754035-f200968a6e72?ixlib=rb-4.0.3&auto=format&fit=crop&w=1800&q=80",
  },
  {
    title: "Hospitality & Dining Solutions",
    subtitle:
      "Stylish Bar Stool and Cafeteria series for restaurants and food service spaces",
    background:
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1800&q=80",
  },
  {
    title: "Tech-Inspired Office Environments",
    subtitle: "Innovative Cyber series for modern tech companies and startups",
    background:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1800&q=80",
  },
  {
    title: "Reception & Collaborative Spaces",
    subtitle:
      "Comfortable Visitor and Office Table series for welcoming areas and teamwork",
    background: `/images/bannerImages/lobby.jpg`,
  },
];
